export default (context, next) => {
  let {api, request, rawReq} = context;

  request.query = {
    method: api.uri,
    param: request.query || {},
    httpMethod: rawReq.method || 'GET',
  };
  // 调用 `application` 通用协议接口
  api.routes = ['application'];
  api.uri = 'invokeJDYGatewayService';
  next();
};



// WEBPACK FOOTER //
// ./src/middlewares/qianniu-pc-gateway-invoke-transform.js